<template>
  <div class="card-item">
    <div v-if="item.url_capa" class="card-item__media" @click="showModalImagem">
      <img :src="item.url_capa" alt="Capa" />
    </div>

    <div class="card-item__body">
      <div class="card-item__title" style="font-weight: 600">{{ item.dsc_titulo_resumido }}</div>
      <div v-if="item.dsc_subtitulo" class="card-item__info">{{ item.dsc_subtitulo }}</div>
      <div class="card-item__meta">
        <span class="meta-source">{{ portalDisplayName(item.cod_portal) }}</span>
        <span class="meta-separator">&bull;</span>
        <span>{{ formatDate(item.dat_modificacao_noticia) }}</span>
        <span class="meta-separator">&bull;</span>
        <span>{{ formatHour(item.dat_modificacao_noticia) }}</span>
      </div>
    </div>

    <div class="card-item__actions">
      <v-tooltip left color="surface_neutral_selected">
        <template v-slot:activator="{ on, attrs }">
          <div
            class="card-action-box card-action-box--delete"
            v-bind="attrs"
            v-on="on"
            @click.prevent="removerNoticiaModerada"
           role="button" aria-label="Remover notícia moderada">
            <v-icon>mdi-arrow-left</v-icon>
          </div>
        </template>
        <span>Remover notícia moderada</span>
      </v-tooltip>

      <ModalEditarNoticia
        :noticia-data="item"
        :cod_noticia="item.cod_noticia"
        :cod_pasta="cod_pasta"

      />

      <v-tooltip
        left
        color="surface_neutral_selected"
        v-if="item.num_ordem_noticia !== dataModerada.totalItems"
      >
        <template v-slot:activator="{ on, attrs }">
          <div
            class="card-action-box card-action-box--edit"
            v-bind="attrs"
            v-on="on"
            @click.prevent="ordenarNoticiaModerada('up')"
           role="button" aria-label="Reordenar notícia moderada">
            <v-icon>mdi-chevron-up</v-icon>
          </div>
        </template>
        <span>Reordenar notícia moderada</span>
      </v-tooltip>

      <v-tooltip
        left
        color="surface_neutral_selected"
        v-if="item.num_ordem_noticia !== 1"
      >
        <template v-slot:activator="{ on, attrs }">
          <div
            class="card-action-box card-action-box--edit"
            v-bind="attrs"
            v-on="on"
            @click.prevent="ordenarNoticiaModerada('down')"
           role="button" aria-label="Reordenar notícia moderada">
            <v-icon>mdi-chevron-down</v-icon>
          </div>
        </template>
        <span>Reordenar notícia moderada</span>
      </v-tooltip>
    </div>

    <ModalImagem
      :dialog="isModalImagemAprovadasVisible"
      @close="closeModalImagem"
      :midia_url="item.url_capa"
    />
  </div>
</template>

<script>
import ModalImagem from "@/components/Modal/ModalImagem.vue";
import ModalEditarNoticia from "@/components/Modal/Noticia/ModalEditarNoticia.vue";
import { apiClient } from "@/services/api";
import { capitalizeString } from "@/utils/capitalizeString";
import { formatDate, formatHour } from "@/utils/dateUtils";
import { mapGetters } from "vuex";
export default {
  props: {
    item: Object,
    dataModerada: { type: [Array, Object] },
    getNoticiasAprovadas: Function,
    getNoticiasModeradas: Function,
    selectedToTarja: String,
    num_coluna_telao: Number,
    pageModerada: Number,
    pageAprovada: Number,
    cod_pasta: Number,
  },
  components: {
    ModalImagem,
    ModalEditarNoticia,
  },
  data() {
    return {
      isModalImagemAprovadasVisible: false,
      midia_url_aprovadas: "",
      media_type: "",
      isSelectedToTarja: false,
      dialogRemoverNoticiaModerada: false,
    };
  },
  computed: {
    ...mapGetters({
      portalDisplayName: "portais/getPortalDisplayName",
    }),
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
  },
  methods: {
    formatDate,
    formatHour,
    async showModalImagem(midia_url_aprovadas) {
      this.isModalImagemAprovadasVisible = true;
      this.midia_url_aprovadas = midia_url_aprovadas;
    },
    async closeModalImagem() {
      this.isModalImagemAprovadasVisible = false;
    },
    capitalize(string) {
      return capitalizeString(string);
    },
    async removerNoticiaModerada() {
      await apiClient
        .post("/noticiasModeradas/removerNoticiaModerada", {
          cod_noticia: this.item.cod_noticia,
          cod_portal: this.item.cod_portal,
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
        })
        .then(async () => {
          this.dialogRemoverNoticiaModerada = false;
          await this.getNoticiasAprovadas({
            cod_portal: this.$store.state.portais.selectedPortal.cod_portal,
            cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
            filtro_texto: this.$store.state.noticias.filtro_aprovadas,
            flg_favorita: this.$store.state.noticias.flg_favorita,
            size: 5,
            page: this.$store.state.noticias.noticiasAprovadas.currentPage,
            cod_pasta: this.cod_pasta,
            cod_editoria: this.$store.state.portais.selectedEditoria,
          });
          await this.getNoticiasModeradas({
            cod_portal: this.$store.state.portais.selectedPortal.cod_portal,
            cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
            filtro_texto: this.$store.state.noticias.filtro_moderadas,
            page: this.$store.state.noticias.noticiasModeradas.currentPage,
            size: 5,
          });
          this.$toast.success("Notícia moderada removida com sucesso!");
        })
        .catch((error) => {
          console.error(error);
          this.$toast.error("Houve um erro ao remover a notícia moderada");
          this.dialogRemoverNoticiaModerada = false;
        });
    },
    async ordenarNoticiaModerada(up_or_down) {
      const cod_producao = this.$store.state.producoes.selectedProducao.cod_producao;
      const cod_portal = this.$store.state.portais.selectedPortal.cod_portal;
      const cod_noticia = this.item.cod_noticia;
      await apiClient
        .patch(
          `noticiasModeradas/ordenarNoticiaModerada/${cod_producao}/${cod_portal}/${cod_noticia}`,
          { up_or_down }
        )
        .then(async () => {
          await this.getNoticiasAprovadas({
            cod_portal: this.$store.state.portais.selectedPortal.cod_portal,
            cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
            filtro_texto: this.$store.state.noticias.filtro_aprovadas,
            flg_favorita: this.$store.state.noticias.flg_favorita,
            size: 5,
            page: this.$store.state.noticias.noticiasAprovadas.currentPage,
            cod_pasta: this.cod_pasta,
            cod_editoria: this.$store.state.portais.selectedEditoria,
          });
          await this.getNoticiasModeradas({
            cod_portal: this.$store.state.portais.selectedPortal.cod_portal,
            cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
            filtro_texto: this.$store.state.noticias.filtro_moderadas,
            page: this.$store.state.noticias.noticiasModeradas.currentPage,
            size: 5,
          });
        })
        .catch((error) => {
          console.error(error);
          this.$toast.error("Erro ao ordenar notícia moderada");
        });
    },
  },
};
</script>
